import { RoomChat } from "@/core/api/room.chat.api"

export default {
  sendChatMessage: async ({dispatch, commit, getters, rootGetters}, data) => {
    commit('PUT_MY_CHAT', data)
    await RoomChat.sendChatMessage(data)
  },
  sendChatEmoticon: async ({dispatch, commit, getters, rootGetters}, data) => {
    RoomChat.addMyEmotion(data.src);
    await RoomChat.sendChatEmoticon(data)
  },
  startShareChat: async ({dispatch, commit, getters, rootGetters}, data) => {
    return await RoomChat.startShareChat(data)
  },
  endShareChat: async ({dispatch, commit, getters, rootGetters}, data) => {
    await RoomChat.endShareChat(data)
  },
  getChatsHistoryList: ({dispatch, commit, getters, rootGetters}, data) => {
    return RoomChat.getChatsHistoryList(data)
  },
  setWhisperTarget: ({dispatch, commit, getters, rootGetters}, data) => {
    let {target, userId} = data;
    if(typeof(userId) === 'object') {
      userId = userId.userId
    }
    if (userId) {
      commit('SET_WHISPER_TARGET', userId);
    } else {
      commit('SET_WHISPER_TARGET');
    }
    commit('SET_WHISPER_TYPE', target)
  },
  addUnReadChat: ({dispatch, commit, getters, rootGetters}, data) => {
    commit('ADD_UNREAD_CHAT');
  },
  resetUnReadChat: ({dispatch, commit, getters, rootGetters}, data) => {
    commit('RESET_UNREAD_CHAT');
  }
}
